module.exports = __webpack_public_path__ + "static/media/redecorating_map_important.02619a5f.svg";